<template>
  <div>
    <div v-if="userChecked">
      <router-view/>
    </div>
    <loading v-if="this.$store.getters.isLoading.length > 0"/>
  </div>
</template>

<script>
import AdminService from "@/services/AdminService";
import Loading from "@/views/Loading.vue";

export default {
  name: "app",

  components: {
    Loading
  },

  data() {
    return {
      userChecked: false
    };
  },

  created: function() {
    this.isLoading = true;
    this.$store.dispatch("setLoading", true);
    if (localStorage.getItem("token") !== null) {
      AdminService.adminInfo()
        .then(response => {
          this.$store.dispatch("setAdmin", response.data.payload);
          this.userChecked = true;
          this.$store.dispatch("setLoading", false);
        })
        .catch(function() {
          //Token expired (401 unauthorized)
          // if (error.response.status == 401) {
          localStorage.removeItem("token");
          this.userChecked = true;
          // }
        });
    } else {
      this.userChecked = true;
      this.$store.dispatch("setLoading", false);
    }
  }
};
</script>